import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload, IoIosClose } from "react-icons/io";

// Local imports
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from '../../../components/Loader';
import moment from 'moment'
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const InvoicesPage = () => {
  const fileName = 'Invoices';
  const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0))
  const [endDate, setEndDate] = useState(new Date().setHours(0, 0, 0, 0))
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [invoicesList, setInvoicesList] = useState([])
  const [childColumns, setChildColumns] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [hasError, setHasError] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const columns = [
    {
      Header: "Invoices Id",
      accessor: "InvoiceNumberID",
      filter: "InvoiceNumberID",
      sortType: "basic",
      Cell: ({ row: { original } }) => (
        <Button variant="link" onClick={() => getChildRecords(original.InvoiceNumberID)} className="grid-action-btn">{original.InvoiceNumberID}</Button>
      )
    },
    {
      Header: "Bill To Id",
      accessor: "BillToId",
      filter: "BillToId",
      sortType: "basic",
    },
    {
      Header: "Bill To Name",
      accessor: "BillToName",
      filter: "BillToName",
      sortType: "basic",
      width: 300
    },
    {
      Header: "Bill To Address Line1",
      accessor: "BillToAddressLine1",
      filter: "BillToAddressLine1",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Bill To Address Line2",
      accessor: "BillToAddressLine2",
      filter: "BillToAddressLine2",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Bill To City",
      accessor: "BillToCity",
      filter: "BillToCity",
      sortType: "basic",
    },
    {
      Header: "Bill To State",
      accessor: "BillToState",
      filter: "BillToState",
      sortType: "basic",
    },
    {
      Header: "Bill To Zip Code",
      accessor: "BillToZipCode",
      filter: "BillToZipCode",
      sortType: "basic",
    },
    {
      Header: "Bill To Country",
      accessor: "BillToCountry",
      filter: "BillToCountry",
      sortType: "basic",
    },
    {
      Header: "Ship To Id",
      accessor: "ShipToId",
      filter: "ShipToId",
      sortType: "basic",
    },
    {
      Header: "Ship To Name",
      accessor: "ShipToName",
      filter: "ShipToName",
      sortType: "basic",
      width: 300
    },
    {
      Header: "Ship To Address Line1",
      accessor: "ShipToAddressLine1",
      filter: "ShipToAddressLine1",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Ship To Address Line2",
      accessor: "ShipToAddressLine2",
      filter: "ShipToAddressLine2",
      sortType: "basic",
      width: 180
    },
    {
      Header: "Ship To City",
      accessor: "ShipToCity",
      filter: "ShipToCity",
      sortType: "basic",
    },
    {
      Header: "Ship To State",
      accessor: "ShipToState",
      filter: "ShipToState",
      sortType: "basic",
    },
    {
      Header: "Ship To Zip Code",
      accessor: "ShipToZipCode",
      filter: "ShipToZipCode",
      sortType: "basic",
    },
    {
      Header: "Ship To Country",
      accessor: "ShipToCountry",
      filter: "ShipToCountry",
      sortType: "basic",
    },
    {
      Header: "Invoice Date",
      accessor: "InvoiceDate",
      filter: "InvoiceDate",
      sortType: "basic",
      filterMethod: (filter, row) => {
        const rowValue = row.original
        return rowValue.datefiled.includes(filter.value)
      }
    },
    {
      Header: "Invoice Status",
      accessor: "InvoiceStatus",
      filter: "InvoiceStatus",
      sortType: "basic",
    },
    {
      Header: "Invoice Shipping Cost",
      accessor: "InvoiceShippingcost",
      filter: "InvoiceShippingcost",
      sortType: "basic",
    },
    {
      Header: "Invoice Discount",
      accessor: "InvoiceDiscount",
      filter: "InvoiceDiscount",
      sortType: "basic",
    },
    {
      Header: "Invoice Sales Tax",
      accessor: "InvoiceSalesTax",
      filter: "InvoiceSalesTax",
      sortType: "basic",
    },
    {
      Header: "Invoice Total ($)",
      accessor: "InvoiceTotal",
      filter: "InvoiceTotal",
      sortType: "basic",
    }, {
      Header: 'Email Id',
      accessor: 'Email',
      filter: 'Email',
      sortType: 'basic',
    }, {
      Header: "Created Date",
      accessor: "CreatedDate",
      filter: "CreatedDate",
      sortType: "basic",
      filterMethod: (filter, row) => {
        const rowValue = row.original
        return rowValue.datefiled.includes(filter.value)
      }
    },
  ];

  const gridColumns = [
    {
      Header: "Invoices Id",
      accessor: "InvoiceNumberID",
      filter: "InvoiceNumberID",
      sortType: "basic",
    },
    {
      Header: "SKU",
      accessor: "SKU",
      filter: "SKU",
      sortType: "basic",
    },
    {
      Header: "NDC",
      accessor: "NDC",
      filter: "NDC",
      sortType: "basic",
    },
    {
      Header: "Product Name",
      accessor: "Product",
      filter: "ProductName",
      sortType: "basic",
      width: 200
    },
    {
      Header: "Invoice Quantity",
      accessor: "InvoiceQuantity",
      filter: "InvoiceQuantity",
      sortType: "basic",
    },
    {
      Header: 'Price ($)',
      accessor: 'InvoiceUnitPrice',
      filter: 'InvoiceUnitPrice',
      sortType: 'basic',
    },
    {
      Header: "Invoice Total ($)",
      accessor: "TotalItem",
      filter: "TotalItem",
      sortType: "basic",
    },
    {
      Header: "Created Date",
      accessor: "CreatedDate",
      filter: "CreatedDate",
      sortType: "basic",
      filterMethod: (filter, row) => {
        const rowValue = row.original
        return rowValue.datefiled.includes(filter.value)
      }
    },

  ];

  const newColumn = gridColumns.slice(0);
  newColumn.splice(6, 2);
  newColumn.splice(0, 1);
  const excelHeder = columns.concat(newColumn);

  let filterStartDate = moment(startDate).format("L")
  let filterEndDate = moment(endDate).format("L")
  const [validated, setValidated] = useState(false)
  const [btnDisable, setBtnDisable] = useState(true)
  const [greaterErr, setGreaterErr] = useState(false)
  const [emptyErr, setEmptyErr] = useState(false)

  const submitHandler = (e) => {
    e.preventDefault()
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault()
      e.stopPropagation()
    } else {
      e.preventDefault()
      if (startDate > endDate) {
        setGreaterErr(true)
        return false
      } else if (startDate < endDate) {
        setGreaterErr(false)
      } else {
        setGreaterErr(false)
      }

      if (startDate === 0) {
        setEmptyErr(true)
        return false
      }

      filterStartDate = moment(startDate).format("L")
      filterEndDate = moment(endDate).format("L")

      getInvoices()
      setBtnDisable(true)
    }
    setValidated(true)
  }

  useEffect(() => {
    getInvoices()
  }, [])

  // Get Child List
  const handleClose = () => {
    setInvoicesList([])
    return setModalShow(false)
  }
  const getChildRecords = async (id) => {
    setLoading(true)
    setModalShow(true)
    await _HttpServices
      .getData(`Api/Inbound/invoices?_startDate=${filterStartDate}&_endDate=${filterEndDate}&id=${id}`)
      .then((data) => {
        const result = data.data
        if (result.length > 0) {
          result.map((res) => {
            res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
            res.InvoiceUnitPrice = "$" + (res.InvoiceUnitPrice * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            res.TotalItem = "$" + (res.TotalItem * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          })

        }

        setInvoicesList(result)
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
        setValidated(false)
        setHasError(true);
      });
  }

  async function getInvoices() {
    setLoading(true)
    await _HttpServices
      .getData(`Api/Inbound/invoices?_startDate=${filterStartDate}&_endDate=${filterEndDate}&id=-1`)
      .then((data) => {
        const response = data.data;
        if (response.length > 0) {
          response.map((res) => {
            res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
            res.InvoiceDate = moment(res.InvoiceDate).format('MM/DD/YYYY');
            res.ReceivedDate = moment(res.ReceivedDate).format('MM/DD/YYYY');
            res.InvoiceSalesTax = res.InvoiceSalesTax == null ? "$0.00" : "$" + (res.InvoiceSalesTax * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            res.InvoiceDiscount = res.InvoiceDiscount == null ? "$0.00" : "$" + (res.InvoiceDiscount * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            res.InvoiceShippingcost = res.InvoiceShippingcost == null ? "$0.00" : "$" + (res.InvoiceShippingcost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            res.InvoiceUnitPrice = res.InvoiceUnitPrice == null ? "$0.00" : "$" + (res.InvoiceUnitPrice * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            res.InvoiceTotal = res.InvoiceTotal == null ? "$0.00" : "$" + (res.InvoiceTotal * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
          })
        }
        const uniqData = Array.from(new Set(response.map(a => a.InvoiceNumberID)))
          .map(id => {
            return response.find(a => a.InvoiceNumberID === id)
          })

        const InvoicesResult = uniqData
        setLoading(false)
        setInvoiceList(response)
        setInvoices(InvoicesResult)
        setValidated(false)
      })
      .catch((e) => {
        setLoading(false)
        setValidated(false);
        setHasError(true);
      });
  }
  return (
    <section className="content">

      {/* Modal */}
      <Modal show={modalShow} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Invoices List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {hasError ? <p>Error occurred. Unable to load invoices.</p> :
            <Fragment>
              {invoicesList.length > 0 ? (
                <ReactTable columns={gridColumns} data={invoicesList} defaultPageSize={10} />
              ) : (
                  <div className="no-data">No data found.</div>
                )}
            </Fragment>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}><IoIosClose className="icon btn-icon" />Close</Button>
        </Modal.Footer>
      </Modal>


      <div className="page-title">
        <h2 className="h2">Invoices</h2>
        {invoices.length > 0 ? <Button type="submit" onClick={() => getExcel(excelHeder, invoiceList, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button> : null}
      </div>

      <Row>
        <Col md={12}>
          <div className="card pt-2 mb-4">
            <div className="card-body">
              <Form noValidate validated={validated} onSubmit={submitHandler}>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <div className="date-picker ungroup-date-picker pos-rl">
                        <Form.Label htmlFor="StartDate">
                          Since
                        </Form.Label>
                        <IoMdCalendar className="icon date-icon" />
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => {
                            setBtnDisable(false)
                            return setStartDate(date)
                          }}
                          onSelect={(date) => {
                            setGreaterErr(false)
                            setBtnDisable(false)
                          }}
                          maxDate={new Date()}
                          required className={greaterErr ? "form-control is-invalid" : "form-control"}
                        />
                        {emptyErr ? <div className="err-feedback">Please select Start Date.</div> : null}
                        {greaterErr ? <div className="err-feedback">Since should not be greater than until date.</div> : null}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <div className="date-picker ungroup-date-picker pos-rl">
                        <Form.Label htmlFor="EndDate">
                          Until
                        </Form.Label>
                        <IoMdCalendar className="icon date-icon" />
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => {
                            setBtnDisable(false)
                            return setEndDate(date)
                          }}
                          onSelect={(date) => {
                            setBtnDisable(false)
                          }}
                          maxDate={new Date()}
                          required className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">Please select End Date.</Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mt-2">
                      <Button type="submit" className="mt-3" disabled={btnDisable}>
                        <IoMdDoneAll className="icon btn-icon" />
                        Submit
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>

          <div className="card pt-2">
            <div className="card-body">
              <div className="inventory-grid">
                {hasError ? <p>Error occurred. Unable to load invoices.</p> :
                  <Fragment>
                    {loading ? <Loader /> : invoices.length > 0 ? (
                      <ReactTable columns={columns} data={invoices} defaultPageSize={10} />
                    ) : (
                        <div className="no-data">No data found.</div>
                      )}
                  </Fragment>
                }
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Footer />
    </section>
  );
};

export default InvoicesPage;
